import Swiper from 'swiper'
import { A11y, Autoplay, Mousewheel, Navigation, Pagination } from 'swiper/modules'

export default class Sliders {
  constructor(slider, index) {
    this.slider = slider
    this.index = index
    this.slides = Array.from(this.slider.querySelectorAll('.swiper-slide'))

    this.options = this.setOptions()
    this.initSlider()
    this.handleResize()
  }

  setOptions() {
    let options = {}

    if( this.slider.classList.contains('swiper--force') ) {
      options = {
        modules: [A11y, Pagination],
        centeredSlides: false,
        height: 400,
        loop: false,
        keyboardControl: false,
        pagination: {
          el: '.swiper-pagination--three-columns',
          clickable: true,
          type: 'bullets',
        },
        spaceBetween: 30,
        speed: 500,
        updateOnWindowResize: true,
        watchOverflow: true,
        breakpoints: {
          0: {
            slidesPerView: 1,
            allowTouchMove: true,
          },
          1024: {
            slidesPerView: 'auto',
            allowTouchMove: false,
          },
        },
        a11y: {
          enabled: true,
          containerRole: 'region',
          containerRoleDescriptionMessage: 'carousel',
          containerMessage: 'Force carousel',
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
          paginationBulletMessage: 'Go to slide {{index}}',
          itemRoleDescriptionMessage: 'slide',
        },
      }
    }

    if( this.slider.classList.contains('swiper--loyalty') ) {
      options = {
        modules: [A11y, Pagination],
        autoHeight: true,
        centeredSlides: false,
        height: 650,
        loop: false,
        keyboardControl: false,
        pagination: {
          el: '.swiper-pagination--three-columns',
          clickable: true,
          type: 'bullets',
        },
        observer: true,
        observeParents: true,
        resizeObserver: true,
        spaceBetween: 30,
        speed: 500,
        updateOnWindowResize: true,
        watchOverflow: true,
        breakpoints: {
          0: {
            slidesPerView: 1,
            allowTouchMove: true,
          },
          1024: {
            slidesPerView: 'auto',
            allowTouchMove: false,
          },
        },
        a11y: {
          enabled: true,
          containerRole: 'region',
          containerRoleDescriptionMessage: 'carousel',
          containerMessage: 'Loyalty and beyond carousel',
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
          paginationBulletMessage: 'Go to slide {{index}}',
          itemRoleDescriptionMessage: 'slide',
        },
      }
    }

    if (this.slider.classList.contains('swiper--partners')) {
      options = {
        modules: [A11y, Autoplay],
        allowTouchMove: false,
        autoHeight: true,
        centeredSlides: true,
        height: 110,
        loop: true,
        slidesPerView: 5,
        spaceBetween: '8%',
        speed: 4000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        updateOnWindowResize: true,
        watchOverflow: true,
        breakpoints: {
          0: {
            slidesPerView: 1.5,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
          },
          1440: {
            slidesPerView: 5,
          }
        },
        a11y: {
          enabled: true,
          containerRole: 'region',
          containerRoleDescriptionMessage: 'carousel',
          containerMessage: 'Partners carousel',
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
          paginationBulletMessage: 'Go to slide {{index}}',
          itemRoleDescriptionMessage: 'slide',
        },
      }
    }

    if (this.slider.classList.contains('swiper--vertical-scroll')) {
      options = {
        modules: [A11y, Mousewheel],
        allowTouchMove: false,
        autoHeight: true,
        centeredSlides: true,
        direction: 'vertical',
        freeMode: true,
        loop: false,
        mousewheel: false,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        slidesPerView: 3,
        speed: 500,
        updateOnWindowResize: true,
        watchOverflow: true,
        a11y: {
          enabled: true,
          containerRole: 'region',
          containerRoleDescriptionMessage: 'carousel',
          containerMessage: 'Vertical carousel',
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
          paginationBulletMessage: 'Go to slide {{index}}',
          itemRoleDescriptionMessage: 'slide',
        },
        on: {
          init: (swiper) => {
            const activeSlide = this.slides[swiper.activeIndex]
            if (activeSlide) {
              const textContainer = activeSlide.querySelector('.text-container h2 span')
              if (textContainer) {
                textContainer.classList.add('multicolor-text')
              }
            }
          },
          slideChange: (swiper) => {
            const activeSlide = this.slides[swiper.activeIndex]
            this.slides.forEach(slide => {
              const textContainer = slide.querySelector('.text-container h2 span')
              if (textContainer) {
                textContainer.classList.remove('multicolor-text')
              }
            })
            if (activeSlide) {
              const textContainer = activeSlide.querySelector('.text-container h2 span')
              if (textContainer) {
                textContainer.classList.add('multicolor-text')
              }
            }
          },
        }
      }
    }

    return options
  }

  initSlider() {
    console.debug('  -> Sliders init')
    let swiperInstance = new Swiper(this.slider, this.options)

    swiperInstance.init()
    this.swiperInstance = swiperInstance

    if( this.slider.classList.contains('swiper--vertical-scroll') ){
      console.log('Vertical Slider init.')
      VerticalScroll.pinSwiper(this.slider, this.swiperInstance);
    }
  }

  handleResize() {
    window.addEventListener('resize', () => {
      if (this.swiper) {
        this.swiper.update()
      }
    })
  }

  destroy() {
    console.debug('  -> Sliders destroy')
    this.swiperInstance.destroy()
  }

  static destroyAll() {
    console.debug('  -> Sliders destroy all')
    Sliders.items.forEach((slider) => {
      slider.destroy()
    })
  }

  static init() {
    console.debug('== Sliders components ==')
    Sliders.items = Array.from(document.querySelectorAll('.swiper')).map(
      (slider, index) => new Sliders(slider, index)
    )
  }


}